import { setProblemAsCompleted, setLessonAsCompleted } from "../../../../services/userService";


export function CheckCode(studentCode, output, checkboxes, user, lessonID) {
    const p1ExpectedOutput = /^Welcome to Java Programming!\n$/;

    if (checkboxes.checkbox1 === false) {
        const testResult = p1ExpectedOutput.test(output)
        if (testResult) {
            setProblemAsCompleted(lessonID + "P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        } else {
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }


    if (checkboxes.checkbox1 === true && checkboxes.checkbox2 === true && checkboxes.checkbox3 === true) {
        setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}